<template lang="pug">
#payment_service
  custom-header(
    :title="payService.area01_Title",
    :subTitle="payService.area01_SubTitle",
    :image="payService.area01_Image",
    :buttonName="payService.area01_ButtonName",
    :buttonURL="payService.area01_ButtonURL"
  )
  section.container.custom_container_sm.i_mt_16.i_pb_10
    h2.i_h2_title.text-center {{ payService.area02_Title }}
    .row
      .col-12.col-md-6.i_mt_10.i_mt_sm_6(
        v-for="(paymentInfo, index) in payService.area02_PayServiceList",
        :key="index"
      )
        card(:paymentInfo.sync="paymentInfo")
  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getPayService } from "@/json/customer_service";
import Card from "@/components/customer_service/Card";
import DedicatedLine from "@/components/customer_service/DedicatedLine";

export default {
  name: "CustomerServicePaymentService",
  metaInfo() {
    return {
      title: this.payService.SEO_Title,
      meta: [{ name: "description", content: this.payService.SEO_Description }],
    };
  },
  components: {
    "custom-header": CustomHeader,
    card: Card,
    "dedicated-line": DedicatedLine,
  },
  data() {
    return {
      payService: {},
    };
  },
  created() {
    this.getPayService();
  },
  methods: {
    getPayService() {
      getPayService().then((response) => {
        this.payService = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
